/** Shared colour-scheme + UI prefs for school/public surfaces (portal, register, renewal). */
export const A11Y_STORAGE_KEY = 'ifip_a11y_prefs_v1';

export const A11Y_SCHEMES = ['default', 'cg', 'wb', 'nb', 'sol'];

/** `html` attribute: hover zoom for non–accessibility controls on the school portal (default off). */
export const HOVER_ZOOM_OTHERS_ATTR = 'data-a11y-hover-zoom-others';

function readPrefs() {
  try {
    const raw = localStorage.getItem(A11Y_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function normalizeScheme(raw) {
  let scheme = raw;
  if (scheme === 'bw') scheme = 'cg';
  return A11Y_SCHEMES.includes(scheme) ? scheme : 'default';
}

export function getInitialA11yScheme() {
  const scheme = readPrefs().colorScheme;
  return normalizeScheme(scheme ?? 'default');
}

export function getInitialHoverZoomOthers() {
  return Boolean(readPrefs().hoverZoomOthers);
}

/** Apply hover-zoom flag to `<html>` (call on boot and after toggling). */
export function syncHoverZoomOthersToDom(enabled) {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute(HOVER_ZOOM_OTHERS_ATTR, enabled ? 'on' : 'off');
}
